import { Loader } from '@dronebase/shared-ui-core';
import { Navigate, Outlet } from 'react-router-dom';

import useFirebaseAuth from 'lib/hooks/useFirebaseAuth';

const ProtectedRoutes = () => {
    const { authUser, loading } = useFirebaseAuth();

    if (loading) {
        return <Loader />;
    }

    if (!authUser) {
        return <Navigate to="/auth" replace />;
    }

    return <Outlet context={authUser} />;
};

export default ProtectedRoutes;
